import { AssetInfo } from './../../../models/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { ApiService } from 'src/app/providers/api.service';
import { Component, Inject, OnInit, OnDestroy, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BuisnessPromotion } from 'src/app/models/common';
import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';

@Component({
  selector: 'sm-add-new-credit',
  templateUrl: './add-new-credit.component.html',
  styleUrls: ['./add-new-credit.component.scss']
})
export class AddNewCreditComponent implements OnInit, OnDestroy {
  public newCreditData: any = {
    amount: null,
    purpose: null,
    aproxRepaymentDate: null,
    repaymentNotes: null,
    paymentMode: 1
  }
  public editCreditData: any = {
    amount: null,
    status: 1
  }
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public loader: boolean = false;
  private _assetInfo: AssetInfo[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private _ngZone: NgZone,
    private loaderservice: LoaderServiceService
  ) {}

  removeAsset(index: any) {
    console.log(index);
    this.assetList.splice(index, 1);
  }

  ngOnInit(): void {
    let data: any = new BuisnessPromotion();

    Object.assign(data, this.parentData.data);
    console.log(data);

      // this.newCreditData = data;
      this.editMode = data.editMode;
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result.url);
        this._ngZone.run(() => {
          this.assetList.push({
            assetName: this.fileName,
            url: res.result?.url,
            thumbnail: res.result?.thumbnail,
          });
          console.log(this.assetList);
          this.loader = false;
        });
        // this.newCreditData.imgUrl = res.result?.url;
      }
      if (res.responseType === SM_CONSTANTS.RESULT_API_UPDATE_USER_EXPENSES_INFO) {
        if(res.result){
          this.parentData.ref.closeAll();
        }
      
      }
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    if(!this.editMode){
      let data = {
        expenseInfo : {
          amount: this.newCreditData.amount,
          purpose: this.newCreditData.purpose,
          aproxRepaymentDate: this.newCreditData.aproxRepaymentDate? this.formatDate((new Date(this.newCreditData.aproxRepaymentDate)).toLocaleDateString()):null,
          repaymentNotes: this.newCreditData.repaymentNotes,
          paymentMode: this.newCreditData.paymentMode,
        }
       }
    
       console.log(data); 
       this.loaderservice.showLoader = true
       this._apiService.updateUserExpenseInfo(this.parentData.data.employeeHash,data,this.parentData.data.entityHash)
    }

    else if (this.editMode){
      let data = {
        expenseInfo : {
          hash_id: this.parentData.data.creditData.hash_id,
          amount: this.editCreditData.amount,
          purpose: this.parentData.data.creditData.purpose,
          aproxRepaymentDate: this.parentData.data.creditData.aproxRepaymentDate? this.formatDateForEdit((new Date(this.parentData.data.creditData.aproxRepaymentDate)).toString()):null,
          repaymentNotes: this.parentData.data.creditData.repaymentNotes,
          paymentMode: this.parentData.data.creditData.payment_mode,
          status: this.editCreditData.status
        }
       }
       console.log(data);
       this.loaderservice.showLoader = true
       this._apiService.updateUserExpenseInfo(this.parentData.data.employeeHash,data,this.parentData.data.entityHash)
       
    }
 

   
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split('/');
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);
  
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, '0');
  
    return `${yyyy}-${mm}-${dd}`;
  }

  formatDateForEdit(originalDate: string) {
    const date = new Date(originalDate);
    
    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getUTCDate()).padStart(2, '0');
  
    return `${yyyy}-${mm}-${dd}`;
  }

  onUploadImage(event: any) {
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;

    if (this.fileName.includes(' ')) {
      this._snackBar.open('White spaces are not allowed in file name', 'OK', {
        duration: 3000,
      });
      return;
    }
    let sizeinKb = +event.target.files[0].size / 1000;
    // if (sizeinKb > 1021) {
    //   this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
    //   return;
    // }
    let extension = this.fileName.substring(this.fileName.lastIndexOf('.') + 1);
    console.log(extension);
    // this.assetList.push({
    //   assetName: this.fileName,
    // });
    this.loader = true;
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
      console.log('image');
      if (sizeinKb > 1021) {
        this.loader = false;
        this._snackBar.open(
          'Image size should not exceed more then 1 mb',
          'Ok'
        );
        return;
      }
      this._apiService.uploadAssets(formData, 1);
      return;
    }
    if (extension === 'mp4' || extension === 'avi') {
      console.log('Video');
      this._apiService.uploadAssets(formData, 3);
      return;
    }
    this.loader = false;
    this._snackBar.open('File format not supported', 'Ok');

    // this._apiService.uploadAssets(formData, 1);
  }

  locationAutoComplete(event: any) {
    console.log('location', event.place.address_components);
    // administrative_area_level_1 = state
    // locality = city
    // country = country
    event.place.address_components?.forEach((data: any) => {
      let type = data.types[0];
      console.log(type);
      if (type === 'administrative_area_level_1') {
        this.newCreditData.targetState = data?.long_name;
      } else if (type === 'locality') {
        this.newCreditData.targetCity = data.long_name;
      } else if (type === 'country') {
        this.newCreditData.targetCountry = data.long_name;
      }
    });
  }
}
